<template>
  <div
    class="time-picker-wrapper position-relative"
    @keyup="handleEnterButton"
  >
    <flat-pickr
      ref="picker"
      v-model="modelValueProxy"
      :config="mergedConfig"
      class="form-control pr-5 cursor-pointer"
      :class="inputClass"
      :placeholder="placeholder"
      :disabled="disabled"
      @on-change="onChange"
    />

    <!-- Icon -->
    <div
      v-if="$slots.icon || icon"
      class="time-picker-icon"
      @click="openPicker"
    >
      <slot name="icon">
        <i :class="icon" />
      </slot>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  name: 'TimePicker',
  components: {
    flatPickr,
  },
  props: {
    value: {
      type: [String, Date],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Pilih Jam',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    modelValueProxy: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    mergedConfig() {
      return {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
        ...this.config,
      }
    },
  },
  methods: {
    openPicker() {
      this.$refs.picker.fp.open()
    },
    onChange(selectedDates, dateStr, instance) {
      this.$emit('input', dateStr)
      this.$emit('on-change', { selectedDates, dateStr, instance })
    },
    handleEnterButton(e) {
      if (e.key === 'Enter') {
        // eslint-disable-next-line no-underscore-dangle
        this.$refs.picker.fp._input.blur()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/vue/libs/vue-flatpicker.scss';

.time-picker-wrapper {
  .time-picker-icon {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input.form-control {
    padding-right: 2.5rem;
    padding-top: .75rem;
    padding-bottom: .75rem;
  }

  .flatpickr-input {
    background-color: #f0f0f0 !important;
  }
}
</style>
